let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFileContainer = styledWithTheme.div(_t || (_t = _`
  border-radius: ${0};
  border: ${0};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-block-start: ${0};
  padding-block: ${0};
  padding-inline-start: ${0};
  background-color: ${0};
  }};
`), ({
  theme
}) => theme.borderRadius['100'], ({
  theme,
  $variant
}) => $variant === 'transparent' ? 'none' : $variant === 'error' ? `${theme.borderWidth['100']} solid ${theme.color['fill-accent-red-default']}` : `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`, ({
  theme,
  $variant
}) => $variant === 'transparent' ? '0' : theme.space['50'], ({
  theme,
  $variant
}) => $variant === 'transparent' ? '0' : theme.space['100'], ({
  theme,
  $variant
}) => $variant === 'transparent' ? '0' : theme.space['200'], ({
  theme,
  $variant
}) => $variant === 'transparent' ? 'transparent' : theme.color['fill-field-default']);
const FileContainer = ({
  variant = 'default',
  children,
  'data-test-id': dataTestId
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledFileContainer, {
      $variant: variant,
      "data-test-id": dataTestId,
      children: children
    })
  );
};
export default FileContainer;